import { Routes, Route, Navigate } from 'react-router-dom';

import RootLayout from './layouts/RootLayout.jsx';
import AppLayout from './layouts/AppLayout.jsx';
import WikiLayout from './layouts/WikiLayout.jsx';
import AdminLayout from './layouts/AdminLayout.jsx';
import ProtectedRoute from './routes/ProtectedRoute.jsx';
import AdminRoute from './routes/AdminRoute.jsx';

import LoginPage from './pages/LoginPage.jsx';
import ClockPage from './pages/ClockPage.jsx';
import TimesheetPage from './pages/TimesheetPage.jsx';
import DocumentsPage from './pages/DocumentsPage.jsx';
import PayPage from './pages/PayPage.jsx';
import ProfilePage from './pages/ProfilePage.jsx';
import MorePage from './pages/MorePage.jsx';
import ExpensesPage from './pages/ExpensesPage.jsx';
import SchedulePage from './pages/SchedulePage.jsx';
import WikiPage from './pages/WikiPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';

import DashboardPage from './pages/admin/DashboardPage.jsx';
import ReportsPage from './pages/admin/ReportsPage.jsx';
import SettingsPage from './pages/admin/SettingsPage.jsx';
import PayRunsPage from './pages/admin/PayRunsPage.jsx';
import PayRunDetailPage from './pages/admin/PayRunDetailPage.jsx';
import JobsPage from './pages/admin/JobsPage.jsx';
import CrewPage from './pages/admin/CrewPage.jsx';
import OnboardingPage from './pages/admin/OnboardingPage.jsx';
import JhaTemplatePage from './pages/admin/JhaTemplatePage.jsx';
import JhaSubmissionsPage from './pages/admin/JhaSubmissionsPage.jsx';
import DocumentsAdminPage from './pages/admin/DocumentsAdminPage.jsx';
import ExpensesAdminPage from './pages/admin/ExpensesAdminPage.jsx';
import GeofencePage from './pages/admin/GeofencePage.jsx';
import LivePage from './pages/admin/LivePage.jsx';
import AdminSchedulePage from './pages/admin/SchedulePage.jsx';
import SessionsPage from './pages/admin/SessionsPage.jsx';
import AuditPage from './pages/admin/AuditPage.jsx';

export default function App() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route path="/login" element={<LoginPage />} />

        {/* Wiki is operational documentation — intentionally public so new
            hires can read it before they sign in and so Playwright e2e
            tests don't need a seeded session. Content has no secrets. */}
        <Route element={<WikiLayout />}>
          <Route path="/wiki"       element={<WikiPage />} />
          <Route path="/wiki/:slug" element={<WikiPage />} />
        </Route>


        <Route element={<ProtectedRoute />}>
          <Route element={<AppLayout />}>
            <Route index element={<Navigate to="/clock" replace />} />
            <Route path="clock"      element={<ClockPage />} />
            <Route path="timesheet"  element={<TimesheetPage />} />
            <Route path="documents"  element={<DocumentsPage />} />
            <Route path="pay"        element={<PayPage />} />
            <Route path="profile"    element={<ProfilePage />} />
            <Route path="more"       element={<MorePage />} />
            <Route path="expenses"   element={<ExpensesPage />} />
            <Route path="schedule"   element={<SchedulePage />} />

            <Route element={<AdminRoute />}>
              <Route path="admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard"  element={<DashboardPage />} />
                <Route path="reports"    element={<ReportsPage />} />
                <Route path="settings"   element={<SettingsPage />} />
                <Route path="pay"        element={<PayRunsPage />} />
                <Route path="pay/:id"    element={<PayRunDetailPage />} />
                <Route path="jobs"       element={<JobsPage />} />
                <Route path="crew"       element={<CrewPage />} />
                <Route path="onboarding" element={<OnboardingPage />} />
                <Route path="jha"        element={<JhaTemplatePage />} />
                <Route path="jha-log"    element={<JhaSubmissionsPage />} />
                <Route path="documents"  element={<DocumentsAdminPage />} />
                <Route path="expenses"   element={<ExpensesAdminPage />} />
                <Route path="geofence"   element={<GeofencePage />} />
                <Route path="live"       element={<LivePage />} />
                <Route path="schedule"   element={<AdminSchedulePage />} />
                <Route path="sessions"   element={<SessionsPage />} />
                <Route path="audit"      element={<AuditPage />} />
              </Route>
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
